import styled from "@emotion/styled";
import { Link as RouterLink } from "react-router-dom";

export const StyledRouterLink = styled(RouterLink)`
  color: ${({ theme }) => theme.colors.primary};
  text-decoration: none;
  font-weight: 600;
  transition:
    opacity 0.2s ease,
    text-decoration 0.2s ease;

  &:hover {
    opacity: 0.8;
    text-decoration: underline;
  }
`;

export const ThemeControlsSection = styled.div`
  padding: 0 1rem;
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
`;

export const ControlLabel = styled.label`
  font-size: 0.75rem;
  color: ${({ theme }) => theme.colors.textMuted};
  margin-top: 0.5rem;
`;
